import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as AddSongsIcon } from '../../icons/music-double-note-plus.svg';
import { ReactComponent as RemoveSongsIcon } from '../../icons/multiple-pages-xmark.svg';
import { ReactComponent as SortIcon } from '../../icons/sort.svg';

import Icon from '../common/Icon';
import PromptModal from '../modals/PromptModal';

import './ServiceActions.scss';

const ServiceActions = ({ onAddSongs, onDeleteFromService, onSortByType, songCount = 0 }) => {
  const { t } = useTranslation();
  const [showClearModal, setShowClearModal] = useState(false);

  const handleClearSongsButton = () => {
    setShowClearModal(true);
  };

  const handleConfirmClear = () => {
    onDeleteFromService(null, true);
  };

  const handleSortSongsButton = () => {
    onSortByType();
  };

  return (
    <>
      <PromptModal
        isOpen={showClearModal}
        onClose={() => setShowClearModal(false)}
        primaryText={t('services.clearAllSongs')}
        message={t('services.clearAllMessage', { count: songCount })}
        onPrimaryAction={handleConfirmClear}
        isDestructive={true}
      />
      <div className="ServiceActions">
        <button className="service-actions-btn" title={t('services.addSongs')} type="button" onClick={onAddSongs}>
          <Icon icon={<AddSongsIcon />} />
        </button>
        <button
          className="service-actions-btn"
          title={t('services.sortByType')}
          type="button"
          onClick={handleSortSongsButton}
          disabled={songCount < 2}
        >
          <Icon icon={<SortIcon />} />
        </button>
        <button
          className="service-actions-btn danger"
          title={t('services.clearSongs')}
          type="button"
          onClick={handleClearSongsButton}
          disabled={songCount === 0}
        >
          <Icon icon={<RemoveSongsIcon />} />
        </button>
      </div>
    </>
  );
};

export default ServiceActions;
